import blablacarImage from './assets/images/blablacar.jpg';
import carismoImage from './assets/images/carismo.jpg';
import commanderImage from './assets/images/commander.jpg';
import dameJidloImage from './assets/images/damejidlo.jpg';
import dodoImage from './assets/images/dodo.jpg';
import goodvisionImage from './assets/images/goodvision.jpg';
import grasonImage from './assets/images/grason.jpg';
import hithitImage from './assets/images/hithit.jpg';
import hoppygoImage from './assets/images/hoppygo.jpg';
import kiwiImage from './assets/images/kiwi.jpg';
import kosikImage from './assets/images/kosik.jpg';
import lafluenceImage from './assets/images/lafluence.jpg';
import liftagoImage from './assets/images/liftago.jpg';
import rekolaImage from './assets/images/rekola.jpg';
import retinoImage from './assets/images/retino.jpg';
import revoltImage from './assets/images/revolt.jpg';
import richeeImage from './assets/images/richee.jpg';
import rohlikImage from './assets/images/rohlik.jpg';
import slevomatImage from './assets/images/slevomat.jpg';
import spendeeImage from './assets/images/spendee.jpg';
import supernovaImage from './assets/images/supernova.jpg';
import taxifyImage from './assets/images/taxify.jpg';
import trisbeeImage from './assets/images/trisbee.jpg';
import twistoImage from './assets/images/twisto.jpg';
import zootImage from './assets/images/zoot.jpg';

const web = 'web';
const mobile = 'mobile';
const startup = 'startup';
const hiring = 'hiring';

export const ITEMS = {
  supernova: {
    id: 'supernova',
    timeCreated: 1543685524,
    product: {
      title: 'Supernova',
      description: 'Turn Sketch designs into native mobile apps in minutes',
      links: {
        websiteUrl: 'https://supernova.io',
      },
      images: {
        macbookMock: supernovaImage,
        appScreenshot: 'https://i.imgur.com/uOyhJOQ.png',
      },
    },
    company: {
      name: 'Supernova',
      companyImage: 'https://pbs.twimg.com/profile_images/971319630466813952/uxrB2am__400x400.jpg',
      companyUrl: 'https://supernova.io',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/supernovaapp',
      twitterUrl: 'https://twitter.com/appsupernova',
    },
  },
  richee: {
    id: 'richee',
    timeCreated: 1542735124,

    product: {
      title: 'Richee',
      hashtags: ['mobile'],

      description:
        'Aplikace Richee umožňuje správu více účtů od českých bank a k tomu si navíc můžete založit skvěle úročený účet s platební kartou.',
      links: {
        websiteUrl: 'https://www.richee.cz/',
        appStoreUrl: 'https://itunes.apple.com/app/id1396421195',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.creditas.richee',
      },
      images: {
        macbookMock: richeeImage,
        appScreenshot: 'https://i.imgur.com/Yp6caT9.png',
      },
    },
    company: {
      name: 'Banka CREDITAS',
      companyImage: 'https://pbs.twimg.com/profile_images/793718698712399872/_mjdlPFJ_400x400.jpg',
      companyUrl: 'https://www.creditas.cz/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/richeeapp',
      twitterUrl: 'https://twitter.com/richeeapp/',
      instagramUrl: 'https://www.instagram.com/richeeapp/',
      youtubeUrl: 'https://www.youtube.com/channel/UCuLcEHwAUAnlH3vJ5kubA3w',
    },
  },

  // fitify: {
  //   id: 'fitify',
  //   timeCreated: 1542648724,

  //   product: {
  //     title: 'Fitify',
  //     technologies: [mobile, startup],
  //     hashtags: ['fitness'],
  //     description:
  //       'Fitify je appka číslo jedna pro hubnutí, pálení kalorií, nabírání svalové hmoty a síly.',
  //     links: {
  //       websiteUrl: 'https://gofitify.com/',
  //       androidStoreUrl:
  //         'https://play.google.com/store/apps/details?id=com.fitifyworkouts.bodyweight.workoutapp',
  //     },
  //     images: {
  //       macbookMock: 'https://cdn.dribbble.com/users/330612/screenshots/4389091/s9.png',
  //       appScreenshot: 'https://cdn.dribbble.com/users/330612/screenshots/4389091/s9.png',
  //     },
  //   },
  //   company: {
  //     name: ' Fitify Workouts',
  //     companyImage: 'https://gofitify.com/img/icon_fitify@2x.png',
  //     companyUrl: 'https://gofitify.com/',
  //   },
  //   social: {
  //     facebookUrl: 'https://www.facebook.com/fitifyapps',
  //     twitterUrl: 'https://twitter.com/FitifyApps',
  //     instagramUrl: 'https://www.instagram.com/fitifyapps/',
  //   },
  // },

  kiwi: {
    id: 'kiwi',
    timeCreated: 1542645124,
    product: {
      title: 'Kiwi',
      technologies: null,
      hashtags: ['flight', 'startup', 'hiring'],
      description:
        'Najděte skryté levné lety a objevte nové destinace pomocí našeho nejmodernějšího vyhledávače letů a interaktivní mapy',
      links: {
        websiteUrl: 'https://www.kiwi.com/',
        appStoreUrl:
          'https://itunes.apple.com/cz/app/kiwi-com-cheap-flight-tickets/id657843853?mt=8',
        androidStoreUrl:
          'https://play.google.com/store/apps/details?id=com.skypicker.main&hl=en_US',
      },
      images: {
        macbookMock: kiwiImage,
        appScreenshot: 'https://i.imgur.com/YvU73No.png',
      },
    },
    company: {
      name: 'Kiwi',
      companyImage:
        'https://scontent-frt3-1.cdninstagram.com/vp/40d3e20452e2fbe84573aa506f0ffc5d/5CAD8710/t51.2885-19/s320x320/22802202_1954843331398449_4244979189549105152_n.jpg',
      companyUrl: 'https://www.kiwi.com/',
      hiringUrl: 'https://www.kiwi.com/jobs/positions/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/bekiwicom/',
      linkedInUrl: 'https://www.linkedin.com/company/kiwi.com/',
      twitterUrl: null,
      instagramUrl: 'https://www.instagram.com/bekiwicom/',
    },
  },

  dameJidlo: {
    timeCreated: 1542115924,
    id: 'dameJidlo',
    product: {
      title: 'Dáme jídlo',
      technologies: null,
      hashtags: ['web', 'mobile', 'hiring'],
      description:
        'Internetová společnost Dáme jídlo se zaměřuje na rozvoz jídla v rámci 130 měst v České republice a na Slovensku',
      links: {
        websiteUrl: 'https://www.damejidlo.cz/',
        appStoreUrl: 'https://itunes.apple.com/app/damejidlo.cz/id582501441',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.ulikeit.damejidlo',
      },
      images: {
        macbookMock: dameJidloImage,
        appScreenshot: 'https://i.imgur.com/0wqJKnX.jpg',
      },
    },
    company: {
      name: 'Dáme jídlo',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/22090119_1636975499701434_4744824847979180978_n.png?_nc_cat=100&_nc_ht=scontent-frt3-1.xx&oh=e3bfbc5d85772c29f9336178d13962b7&oe=5C75B8E9',
      companyUrl: 'https://www.damejidlo.cz',
      hiringUrl: 'https://www.damejidlo.cz/volne-pozice',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/DameJidlo/',
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: 'https://www.instagram.com/damejidlo_cz/',
    },
  },

  liftago: {
    timeCreated: 1542029524,
    id: 'liftago',
    product: {
      title: 'Liftago',
      technologies: null,
      hashtags: ['taxi', 'doprava', 'web', 'mobile', 'hiring'],
      description:
        'Liftago je český startup, který vytváří technologickou platformu pro optimalizaci městské dopravy v České republice i v zahraničí. ',
      links: {
        websiteUrl: 'http://www.liftago.cz/',
        appStoreUrl: 'https://itunes.apple.com/app/apple-store/id633928711',
        androidStoreUrl:
          'https://play.google.com/store/apps/details?id=com.adleritech.app.liftago.passenger',
      },
      images: {
        macbookMock: liftagoImage,
        appScreenshot: 'https://i.imgur.com/HbyI1lF.jpg',
      },
    },
    company: {
      name: 'Liftago',
      companyImage: 'https://pbs.twimg.com/profile_images/765630887652368384/suZ-SYuk_400x400.jpg',
      companyUrl: 'http://www.liftago.cz/',
      hiringUrl: 'https://www.startupjobs.cz/startup/liftago',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/Liftago',
      linkedInUrl: 'https://www.linkedin.com/company/liftago/',
      twitterUrl: 'https://twitter.com/Liftago',
      youtube: 'https://www.youtube.com/user/LiftagoChannel',
    },
  },

  taxify: {
    id: 'taxify',
    timeCreated: 1541943124,
    product: {
      title: 'Taxify',
      technologies: null,
      hashtags: ['taxi', 'doprava', 'web', 'mobile', 'hiring'],
      description:
        'Taxify je mezinárodní dopravní síť založena v hlavním městě Estonska Tallin. Společnost vyvíjí a provozuje mobilní aplikaci Taxify na objednání taxi.',
      links: {
        websiteUrl: 'https://taxify.eu/cs/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/taxify/id675033630?mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=ee.mtakso.client',
      },
      images: {
        macbookMock: taxifyImage,
        appScreenshot: 'https://i.imgur.com/ubTEkle.jpg',
      },
    },
    company: {
      name: 'Taxify',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t31.0-8/14691280_197814783985929_3178415575924626601_o.png?_nc_cat=111&_nc_ht=scontent-frt3-1.xx&oh=d13a0b4109a3b49a344603f7e8a1e9f0&oe=5CA8D59B',
      companyUrl: 'https://taxify.eu/cs/',
      hiringUrl: 'https://careers.taxify.eu/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/TaxifyCzechRepublic/?brand_redir=735407756487400',
      twitterUrl: 'https://twitter.com/taxifyapp',
      instagramUrl: 'https://www.instagram.com/taxify/',
    },
  },

  rekola: {
    id: 'rekola',
    timeCreated: 1541856724,
    product: {
      title: 'Rekola',
      technologies: null,
      hashtags: ['bikesharing', 'sdílená ekonomika', 'mobile'],
      description:
        'Půjčte si růžové kolo kdykoli se vám zachce. Jezděte tak dlouho, jak budete potřebovat a nakonec kolo kdekoli v zóně zamkněte pro dalšího jezdce.',
      links: {
        websiteUrl: 'https://www.rekola.cz/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/rekola/id888759232?mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.rekola.app&hl=cs',
      },
      images: {
        macbookMock: rekolaImage,
        appScreenshot: 'https://i.imgur.com/TiiFHId.png',
      },
    },
    company: {
      name: 'Rekola Bikesharing',
      companyImage: 'https://pbs.twimg.com/profile_images/882210265634394112/fIXfOQsB_400x400.jpg',
      companyUrl: 'https://www.rekola.cz/',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/RekolaEU/',
      linkedInUrl: null,
      twitterUrl: 'https://twitter.com/RekolaEU',
      instagramUrl: 'https://www.instagram.com/rekolaeu/',
    },
  },

  hoppygo: {
    id: 'hoppygo',
    timeCreated: 1541770324,
    product: {
      title: 'HoppyGo',
      technologies: null,
      hashtags: ['car sharing', 'web'],
      description:
        'Jsme peer-to-peer car sharing HoppyGo.com. Spojujeme lidi, kteří potřebují půjčit auto s těmi, kteří ho mohou půjčit.',
      links: {
        websiteUrl: 'https://www.hoppygo.com/?lang=cs',
        appStoreUrl: 'https://itunes.apple.com/us/app/smilecar/id1184613465?ls=1&mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.nom.smilecarweb',
      },
      images: {
        macbookMock: hoppygoImage,
        appScreenshot: 'https://i.imgur.com/YAuyQYr.jpg',
      },
    },
    company: {
      name: 'HoppyGo',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/36342579_1573737729401511_169288730132086784_n.png?_nc_cat=110&_nc_ht=scontent-frt3-1.xx&oh=97be699896caee9fe8a61238aed2191d&oe=5C66B8E1',
      companyUrl: 'https://www.hoppygo.com/?lang=cs',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/HoppyGoCZ/',
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: null,
    },
  },

  slevomat: {
    id: 'slevomat',
    timeCreated: 1541683924,
    product: {
      title: 'Slevomat',
      technologies: null,
      hashtags: ['web', 'mobile', 'hiring'],
      description:
        'Slevomat je vaše cesta k zážitkům. Denně spouštíme přes 200 nových nabídek od ověřených partnerů z oblasti zábavy, cestování, gastronomie či relaxace',
      links: {
        websiteUrl: 'https://www.slevomat.cz/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/slevomat/id402439743?mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.slevomat&hl=cs',
      },
      images: {
        macbookMock: slevomatImage,
        appScreenshot: 'https://i.imgur.com/HDJWeoj.jpg',
      },
    },
    company: {
      name: 'Slevomat',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t31.0-8/18556688_10154701751417852_2276577374693219685_o.png?_nc_cat=1&_nc_ht=scontent-frt3-1.xx&oh=b251d261e7a1dd1c19780f86fe45a5d7&oe=5CAE7D21',
      companyUrl: 'https://www.slevomat.cz/',
      hiringUrl: 'https://www.slevomat.cz/prace',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/slevomat',
      youtube: 'https://www.youtube.com/user/slevomat',
      twitterUrl: 'https://twitter.com/slevomat',
      instagramUrl: 'https://www.instagram.com/slevomat/',
    },
  },

  spendee: {
    id: 'spendee',
    timeCreated: 1541511124,
    product: {
      title: 'Spendee',
      technologies: null,
      hashtags: ['finance', 'hiring', 'mobile'],
      description:
        'Spendee je nejoblíběnější aplikací na správu osobních a rodinných financí. Díky Spendee jednoduše zjistíte, kam plynou a odkud přicházejí vaše peníze.',
      links: {
        websiteUrl: 'https://www.spendee.com/',
        appStoreUrl: 'https://itunes.apple.com/app/spendee/id635861140',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.cleevio.spendee',
      },
      images: {
        macbookMock: spendeeImage,
        appScreenshot: 'https://i.imgur.com/grB6qG0.png',
      },
    },
    company: {
      name: 'Cleevio',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t31.0-8/12375228_10153838514086719_7529035418657833060_o.png?_nc_cat=107&_nc_ht=scontent-frt3-1.xx&oh=c54462afcda3fd1f92842dd47787b757&oe=5C74B2A4',
      companyUrl: 'https://cleevio.com/home',
      hiringUrl: 'https://cleevio.com/jobs',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/spendeeapp/',
      youtube: 'https://www.youtube.com/user/slevomat',
      twitterUrl: 'https://twitter.com/spendeeapp',
      instagramUrl: 'https://www.instagram.com/spendeeapp/',
    },
  },

  rohlik: {
    id: 'rohlik',
    timeCreated: 1541424724,
    product: {
      title: 'Rohlík',
      technologies: null,
      hashtags: ['potraviny', 'rozvoz', 'jídlo', 'miton', 'hiring', 'web', 'mobile'],
      description:
        'Zapomeňte na těžké tašky, dlouhé řady nebo vzdychání nad žalostným stavem zeleniny. Ty nejkvalitnější a čerstvé potraviny dovezeme až k vašim dveřím.',
      links: {
        websiteUrl: 'https://www.rohlik.cz',
        appStoreUrl: 'https://itunes.apple.com/cz/app/rohlik.cz/id975560575?mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.rohlik.app',
      },
      images: {
        macbookMock: rohlikImage,
        appScreenshot: 'https://i.imgur.com/hcplr1c.png',
      },
    },
    company: {
      name: 'Rohlík',
      companyImage: 'https://pbs.twimg.com/profile_images/683237598693728256/gO6ecipf_400x400.png',
      companyUrl: 'https://www.rohlik.cz/',
      hiringUrl: 'https://www.rohlik.cz/stranka/volna-mista',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/damerohlik/',
      linkedInUrl: 'null',
      twitterUrl: 'https://twitter.com/rohlikcz',
      instagramUrl: 'https://www.instagram.com/rohlik.cz/',
      youtube: 'https://www.youtube.com/channel/UCujKbgc3b9dknzX9jwI8yOA',
    },
  },

  kosik: {
    id: 'kosik',
    timeCreated: 1541338324,
    product: {
      title: 'Košík',
      technologies: null,
      hashtags: ['potraviny', 'rozvoz', 'jídlo', 'web', 'hiring'],
      description:
        'Košík.cz přizpůsobujeme na míru vám. Na základě vašeho chování na webu personalizujeme jeho obsah a zobrazujeme vám relevantní nabídky a produkty.',
      links: {
        websiteUrl: 'https://www.kosik.cz/',
        appStoreUrl:
          'https://itunes.apple.com/us/app/ko%C5%A1%C3%ADk-cz/id1263819425?l=cs&ls=1&mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.kosik',
      },
      images: {
        macbookMock: kosikImage,
        appScreenshot: 'https://i.imgur.com/HUIBRzw.jpg',
      },
    },
    company: {
      name: 'Mall Group',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/20798984_1776262566007384_7806897378596486291_n.png?_nc_cat=100&_nc_ht=scontent-frt3-1.xx&oh=2387011689bf2163762889d50da3d1f2&oe=5C753776',
      companyUrl: 'http://mallgroup.cz/',
      hiringUrl: 'https://www.kosik.cz/spolecnost/kontakt',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/kosikcz',
      twitterUrl: 'https://twitter.com/kosikcz',
      instagramUrl: 'https://www.instagram.com/kosik.cz/',
    },
  },

  twisto: {
    id: 'twisto',
    timeCreated: 1541251924,
    product: {
      title: 'Twisto',
      technologies: ['phyton', 'swift', 'postgre', 'redis'],
      hashtags: [web, mobile, startup, hiring],
      city: 'Praha',
      description:
        'Platební aplikace, která platí za vás, bez použití vašich peněz, bez navázání na váš bankovní účet.',
      links: {
        websiteUrl: 'http://twisto.cz/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/twisto/id1182925330',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.twisto.app',
      },
      images: {
        macbookMock: twistoImage,
        appScreenshot: 'https://i.imgur.com/g03y55x.png',
      },
    },
    company: {
      name: 'Twisto payments',
      companyImage:
        'https://scontent-frt3-1.cdninstagram.com/vp/3af78107cf4f227f4d4f533fddbd933f/5C966A22/t51.2885-19/s320x320/25013550_525172517841828_245520684489375744_n.jpg',
      companyUrl: 'https://www.twisto.cz/',
      hiringUrl: 'https://www.twisto.cz/o-nas/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/twisto.cz/',
      linkedInUrl: 'https://www.linkedin.com/company/mews-systems/',
      twitterUrl: 'https://twitter.com/MewsSystems',
      instagramUrl: 'https://www.instagram.com/twisto_cz/',
    },
  },
  mewsCommander: {
    id: 'mewsCommander',
    timeCreated: 1541165524,
    product: {
      title: 'Commander',
      technologies: ['es6', 'react', 'redux', 'webpack'],
      hashtags: [web, mobile, startup, hiring],
      year: 2018,
      city: 'Praha',
      description:
        'Mews makes cloud-based property management software for hospitality operations.',
      productImage: 'https://i.imgur.com/ftyaPvt.png',
      links: {
        websiteUrl: 'http://mews.li/navigator',
        androidStoreUrl:
          'https://play.google.com/store/apps/details?id=li.mews.android.commander&hl=en_US',
      },
      images: {
        macbookMock: commanderImage,
        appScreenshot: 'https://i.imgur.com/Nmheodp.jpg',
      },
    },
    company: {
      name: 'Mews systems',
      companyImage: 'https://pbs.twimg.com/profile_images/756452276236083200/PcoFu5I2_400x400.jpg',
      companyUrl: 'https://www.mewssystems.com/',
      hiringUrl: 'https://mews-systems.breezy.hr/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/twisto.cz/',
      instagramUrl: 'https://www.instagram.com/mewssystems/',
      youtubeUrl: 'https://www.youtube.com/channel/UCjWuMNAUojZh0Y8-WSb0p3A',
    },
  },
  carismo: {
    id: 'carismo',
    product: {
      title: 'Carismo',
      technologies: ['startup', 'web'],
      hashtags: [],
      description:
        'Prodej nových vozů všech značek. Nové vozy bez starostí a na míru zákazníkovi. Oficiální dealeři. Pouze vozy s originální zárukou.',
      links: {
        websiteUrl: 'https://www.carismo.cz',
      },
      images: {
        macbookMock: carismoImage,
        appScreenshot: 'https://i.imgur.com/RmEkXhw.jpg',
      },
    },
    company: {
      name: 'Carismo',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/40152266_2256095741286931_2927160756438827008_n.png?_nc_cat=100&_nc_ht=scontent-frt3-1.xx&oh=2c6e31817450412497f4352070a28e42&oe=5C9D7E73',
      companyUrl: 'https://www.carismo.cz',
      hiringUrl: 'https://www.carismo.cz/o-nas/kariera',
    },
    social: {
      facebookUrl: 'https://www.instagram.com/carismoCZ/',
      linkedInUrl: 'https://www.linkedin.com/company/carismo/',
      twitterUrl: 'https://twitter.com/carismoCZ',
      instagramUrl: 'https://www.facebook.com/carismo.cz',
    },
  },

  zoot: {
    id: 'zoot',
    product: {
      title: 'Zoot',
      technologies: null,
      hashtags: [],
      description:
        'Jsme ZOOT. Internetový obchod s módou, ve kterém najdete přes 300 originálních značek a 300 000 kousků skladem. ',
      links: {
        websiteUrl: 'https://www.zoot.cz/',
        appStoreUrl: null,
        androidStoreUrl: null,
      },
      images: {
        macbookMock: zootImage,
        appScreenshot: 'https://i.imgur.com/bYMYU2P.jpg',
      },
    },
    company: {
      name: 'Zoot',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/12112116_1240187469340045_3741779093838380228_n.jpg?_nc_cat=1&_nc_ht=scontent-frt3-1.xx&oh=a1a1d69c93f84ac8eeee6679c1af4f38&oe=5CA635A0',
      companyUrl: 'https://www.zoot.cz/',
      hiringUrl: 'https://www.chcidozootu.cz/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/udelejtesiradost/?brand_redir=1508657652792974',
      linkedInUrl: 'https://www.linkedin.com/company/zoot-a-s-/',
      twitterUrl: 'https://twitter.com/ZOOT_cz',
      instagramUrl: null,
      youtubeUrl: 'https://www.youtube.com/channel/UCZjzyTXngfY2nzV_z9L60Qw',
    },
  },

  trisbee: {
    id: 'trisbee',
    product: {
      title: 'Trisbee',
      technologies: ['Swift', 'Firebase', 'Java', 'Kotlin'],
      hashtags: ['web', 'mobile', 'startup', 'hiring'],
      description:
        'Plaťte kartou kdekoliv, začněte používat aplikaci Trisbee. Příjímejte platby kartou, jednoduše přes mobil.',
      links: {
        websiteUrl: 'https://www.trisbee.com/',
        appStoreUrl: 'https://itunes.apple.com/us/app/trisbee-go/id1411327265',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.primaplatba.ppvendorapp',
      },
      images: {
        macbookMock: trisbeeImage,
        appScreenshot: 'https://i.imgur.com/U3FvB4g.png',
      },
    },
    company: {
      name: 'Trisbee',
      companyImage:
        'https://is5-ssl.mzstatic.com/image/thumb/Purple128/v4/b9/1a/db/b91adb2a-b3c6-fa53-4a07-646585731e50/source/512x512bb.jpg',
      companyUrl: 'https://www.trisbee.com/',
      hiringUrl: 'https://www.trisbee.com/jobs/',
    },
    social: {
      facebookUrl: null,
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: null,
    },
  },

  retino: {
    id: 'retino',
    product: {
      title: 'Retino',
      technologies: null,
      hashtags: ['web', 'startup'],
      description:
        'Retino je online aplikace pro správu vratek v e-commerce. Zvyšte retenci zákazníků, umožněte efektivní provoz a najděte skrytou hodnotu ve svých datech.',
      links: {
        websiteUrl: 'https://www.retino.io/',
      },
      images: {
        macbookMock: retinoImage,
        appScreenshot: 'https://i.imgur.com/4c7GUhI.jpg',
      },
    },
    company: {
      name: 'Trisbee',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/29178666_430283194061643_4078580628809842688_n.png?_nc_cat=104&_nc_ht=scontent-frt3-1.xx&oh=d7a0049ac355467f2d7bb8a0312c420a&oe=5C9FF22C',
      companyUrl: 'https://www.retino.io/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/retino.io/',
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: null,
    },
  },

  hithit: {
    id: 'hithit',
    product: {
      title: 'Hithit',
      technologies: null,
      hashtags: ['web'],
      description:
        'Hithit propojuje kreativní lidi s těmi, kteří je chtějí podpořit. Plní sny umělcům, kreativcům, designérům, vývojářům, géniům.',
      links: {
        websiteUrl: 'https://www.hithit.com/cs/home',
        appStoreUrl: null,
        androidStoreUrl: null,
      },
      images: {
        macbookMock: hithitImage,
        appScreenshot: 'https://i.imgur.com/mQ0ROwD.jpg',
      },
    },
    company: {
      name: 'hithit',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/14448987_708399235979386_2375089289619634003_n.png?_nc_cat=102&_nc_ht=scontent-frt3-1.xx&oh=94f7c3386d8aca4a4b4b65d110f47853&oe=5C725991',
      companyUrl: 'https://www.hithit.com/cs/home',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/hithit.cz',
      linkedInUrl: null,
      twitterUrl: 'https://twitter.com/HITHITCZ',
      instagramUrl: null,
      youtubeUrl: 'https://www.youtube.com/user/HITHITCZ',
    },
  },

  blaBlaCar: {
    id: 'blaBlaCar',
    product: {
      title: 'BlaBlaCar',
      technologies: null,
      hashtags: ['web', 'mobile', 'startup', 'hiring'],
      description:
        'BlaBlaCar je největší služba pro spolujízdu v Evropě, která spojuje řidiče s volnými místy v autě s lidmi, kteří jedou stejným směrem.',
      links: {
        websiteUrl: 'https://www.blablacar.cz/',
        appStoreUrl: 'https://itunes.apple.com/app/blablacar/id341329033',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.comuto&hl=cs',
      },
      images: {
        macbookMock: blablacarImage,
        appScreenshot: 'https://i.imgur.com/a9qr70i.jpg',
      },
    },
    company: {
      name: 'BlaBlaCar',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/27067820_1634286646617883_6394484759771199614_n.png?_nc_cat=103&_nc_ht=scontent-frt3-1.xx&oh=9ae8753497024b124e852c86cfad1c21&oe=5CA5889C',
      companyUrl: 'https://www.blablacar.cz/',
      hiringUrl: 'https://blog.blablacar.cz/dreamjobs',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/BlaBlaCarCR',
      linkedInUrl: null,
      twitterUrl: 'https://twitter.com/BlaBlaCarCR',
      instagramUrl: 'https://www.instagram.com/blablacar/',
      youtubeUrl: 'https://www.youtube.com/c/BlaBlaCarCZ',
    },
  },

  reVolt: {
    id: 'reVolt',
    product: {
      title: 're.volt',
      technologies: null,
      hashtags: [],
      description:
        'Hledáš něco mezi taxi a městskou hromadnou dopravou? Náš Re.volt Tě dostane kamkoliv a kdykoliv !',
      links: {
        websiteUrl: 'https://revolt.city/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/revolt-carsharing/id1396538545?l=cs&mt=8',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=cz.revolt.carsharing',
      },
      images: {
        macbookMock: revoltImage,
        appScreenshot: 'https://i.imgur.com/nBGzUka.png',
      },
    },
    company: {
      name: 're.volt',
      companyImage:
        'https://scontent-frt3-1.cdninstagram.com/vp/b8e7944c6d06820abe3557afcb495dce/5CA7F3E9/t51.2885-19/s320x320/30842016_1096960317111125_5976285076411908096_n.jpg',
      companyUrl: 'https://revolt.city/',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/revolt.city.carsharing/',
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: 'https://www.instagram.com/revolt.carsharing/',
      youtubeUrl: 'https://www.youtube.com/channel/UCJgOKy7REzUjb4gCNF7v6iA',
    },
  },

  lafluence: {
    id: 'lafluence',
    product: {
      title: 'Lafluence',
      hashtags: ['startup', 'web'],
      description:
        'Dohodni si spolupráci se super značkami. Registrace je zdarma a zabere ti jen 3 minuty. lafluence.',
      links: {
        websiteUrl: 'https://lafluence.com/',
      },
      images: {
        macbookMock: lafluenceImage,
        appScreenshot: 'https://i.imgur.com/0OhADRh.jpg',
      },
    },
    company: {
      name: 'Lafluence',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/17362572_626194250924552_1594428238565485644_n.png?_nc_cat=103&_nc_ht=scontent-frt3-1.xx&oh=433b5622947766fe34fa6b41983b73b3&oe=5C6A827B',
      companyUrl: 'https://lafluence.com/',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/lafluence',
      linkedInUrl: null,
      twitterUrl: null,
      instagramUrl: 'https://www.instagram.com/lafluenceapp/',
    },
  },

  goodVision: {
    id: 'goodVision',
    product: {
      title: 'GoodVision',
      hashtags: ['startup', 'web'],
      description: 'GoodVision se specializuje na analýzu videa pomocí umělé inteligence',
      links: {
        websiteUrl: 'https://goodvisionlive.com/',
      },
      images: {
        macbookMock: goodvisionImage,
        appScreenshot: 'https://i.imgur.com/obTK5sT.jpg',
      },
    },
    company: {
      name: 'GoodVision',
      companyImage: 'https://pbs.twimg.com/profile_images/879052176190058497/WCiPDjwc_400x400.jpg',
      companyUrl: 'https://goodvisionlive.com/',
      hiringUrl: 'https://goodvisionlive.com/#contact',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/goodvisionlive/',
      linkedInUrl: 'https://www.linkedin.com/company/goodvision/',
      twitterUrl: 'https://twitter.com/goodvisionlive',
      youtubeUrl: 'https://www.youtube.com/channel/UCrrhdeQpkpsfOH8e8tJ6y2A?view_as=subscriber',
    },
  },

  grason: {
    id: 'grason',
    product: {
      title: 'grason',
      hashtags: ['mobile', 'startup'],
      description: 'Najdi směnu, odpracuj, dostaň zaplaceno. Jednoduše v mobilní appce.',
      links: {
        websiteUrl: 'https://www.grason.cz/',
        appStoreUrl: 'https://itunes.apple.com/cz/app/grason-cz/id1367384162',
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.thefuntasty.grason',
      },
      images: {
        macbookMock: grasonImage,
        appScreenshot: 'https://i.imgur.com/UijSRVR.jpg',
      },
    },
    company: {
      name: 'Grason',
      companyImage:
        'https://scontent-frt3-1.xx.fbcdn.net/v/t1.0-9/43232866_725028671176544_3144231212487278592_n.png?_nc_cat=101&_nc_ht=scontent-frt3-1.xx&oh=8be2ff283fbfb80d7d07473dc060b4a7&oe=5C668ADE',
      companyUrl: 'https://www.grason.cz/',
      hiringUrl: null,
    },
    social: {
      facebookUrl: 'https://www.facebook.com/Grason.cz/',
    },
  },

  doDo: {
    id: 'doDo',
    product: {
      title: 'Dodo',
      technologies: null,
      hashtags: ['hiring', 'web', 'startup'],
      description:
        'Osobní asistent #DODO, který šetří čas i nervy. Vyřídí a doručí v dohodnutém čase za Vámi schválenou cenu #chcidodo',
      links: {
        websiteUrl: 'https://idodo.cz/',
        appStoreUrl: null,
        androidStoreUrl: null,
      },
      images: {
        macbookMock: dodoImage,
        appScreenshot: 'https://i.imgur.com/Cf8qaQP.png',
      },
    },
    company: {
      name: 'DoDo',
      companyImage: 'https://pbs.twimg.com/profile_images/879629695742095360/mbKsNuLY_400x400.jpg',
      companyUrl: 'https://idodo.cz/',
      hiringUrl: 'https://idodo.cz/kariera/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/chcidodo/',
      linkedInUrl: 'https://www.linkedin.com/company/dodoczech/',
      twitterUrl: 'https://twitter.com/chcidodo',
      instagramUrl: 'https://www.instagram.com/chcidodo/',
    },
  },

  // name: {
  //   id: null,
  //   product: {
  //     title: null,
  //     technologies: null,
  //     hashtags: [],
  //     description:
  //       '',
  //     links: {
  //       websiteUrl: null,
  //       appStoreUrl: null,
  //       androidStoreUrl: null
  //     },
  //     images: {
  //       macbookMock: null,
  //       appScreenshot: null,
  //     },
  //   },
  //   company: {
  //     name: null,
  //     companyImage:
  //       null,
  //     companyUrl: null,
  //     hiringUrl: null,
  //   },
  //   social: {
  //     facebookUrl: null,
  //     linkedInUrl: null,
  //     twitterUrl: null,
  //     instagramUrl: null,
  //   },
  // },

  // {
  //   id: 'fitify',
  //   bgSrc:
  //     'https://cdn.dribbble.com/users/330612/screenshots/4707627/attachments/1061834/fitify-casestudy-dribbble-preview.png',
  //   title: 'Fitify',
  //   description:
  //     'Fitify is your ultimate workout app to lose weight, burn fat, build muscle & strength at home.',
  //   websiteUrl: 'https://fitifyapps.com/',
  // },

  // {
  //   id: 'wolt',
  //   bgSrc: 'https://i.imgur.com/s6pcpGH.jpg',
  //   title: 'Wolt',
  //   description:
  //     'Wolt je původem finská služba, která zajišťuje rozvoz jídel z restaurací. Je to v podstatě přímá konkurence pro české DámeJídlo.',
  //   websiteUrl: 'https://wolt.com/cz',
  // },

  // {
  //   id: 'driveto',
  //   bgSrc: 'https://i.imgur.com/pLKUPpp.png',
  //   title: 'Driveto',
  //   description:
  //     'Největší a nejpoužívanější službu v České republice pro výběr auta na operativní leasing.',
  //   websiteUrl: 'https://www.driveto.cz',
  // },

  // {
  //   id: 'productboard',
  //   bgSrc: 'https://i.imgur.com/SBOqwUL.png',
  //   title: 'Productboard',
  //   description:
  //     'Productboard vytváří nástroj pro firmy a jejich produktové manažery, jimž dává holistický pohled na vývoj produktu.',
  //   websiteUrl: 'https://www.productboard.com',
  // },
  // {
  //   id: 'rohlik',
  //   bgSrc: 'https://i.imgur.com/hcplr1c.png',
  //   title: 'Rohlík',
  //   description: 'On-line nákup a rozvoz potravin.',
  //   websiteUrl: 'https://www.rohlik.cz',
  // },
  // {
  //   id: 'ueni',
  //   bgSrc: 'https://i.imgur.com/flFXSo3.png',
  //   title: 'UENI',
  //   description:
  //     'Pronounced "You and I", UENI provides low-cost, easy solutions solutions to help small businesses attract new customers online.',
  //   websiteUrl: 'https://ueni.com/en-gb/business',
  // },

  // {
  //   id: 'vyvolej-to',
  //   bgSrc: 'https://i.imgur.com/bH2sX3X.png',
  //   title: 'Vyvolej.to ',
  //   description:
  //     'vyvolej.to je designový on-line fotolab. Inspirujeme k radosti z fotek, které můžete vzít do ruky a opravdu je sdílet.',
  //   websiteUrl: 'https://www.vyvolej.to',
  // },
  // {
  //   id: 'rekola',
  //   bgSrc: 'https://i.imgur.com/TiiFHId.png',
  //   title: 'Rekola',
  //   description: 'Sdílená kola pro rychlé přesuny po městě',
  //   websiteUrl: 'https://www.rekola.cz',
  // },

  // {
  //   bgSrc: 'https://i.imgur.com/C4Bj6Gm.png',
  //   title: 'Attacama One',
  //   websiteUrl: 'https://www.ataccama.com/',
  //   description:
  //     'Platforma na bázi strojového učení, který umožňuje zkoumat, profilovat a spravovat data',
  // },
  // {
  //   bgSrc: 'https://i.imgur.com/stenEkw.png',
  //   title: 'Zonky',
  //   websiteUrl: 'https://zonky.cz/',
  //   description: 'Lidé půjčují lidem za výhodnější úrok než u banky',
  // },
  // {
  //   bgSrc: 'https://i.imgur.com/Yp6caT9.png',
  //   title: 'Richee',
  //   description: 'první česká multibankovní aplikaci Richee',
  //   websiteUrl: 'https://www.richee.cz/',
  // },
  // {
  //   title: 'Valuo',
  //   websiteUrl: 'https://www.valuo.cz/',
  //   description: 'Hlavní misí realitního webu value je boj s rostoucími ceny nemovitostí',
  //   bgSrc: 'https://i.imgur.com/VH92iPu.png',
  // },
  // {
  //   title: 'Supernova studio',
  //   websiteUrl: 'https://supernova.io',
  //   bgSrc: 'https://i.imgur.com/uOyhJOQ.png',

  //   description: 'Turn Sketch designs into native mobile apps in minutes',
  // },

  // {
  //   title: 'Avocode',
  //   websiteUrl: 'https://avocode.com',
  //   isHiring: true,
  //   hiringUrl: 'https://avocode.com/jobs',
  //   description: 'Avocode zjednodušuje práci designérů a vývojářů.',
  //   bgSrc: 'https://i.imgur.com/NiNSWJm.png',
  // },
  // {
  //   title: 'Flatio',
  //   websiteUrl: 'https://www.flatio.cz/',
  //   bgSrc: 'https://i.imgur.com/fooLOD8.png',
  //   description: 'Bydlení na pár měsíců',
  // },
  // {
  //   title: 'UlovDomov',
  //   websiteUrl: 'https://www.ulovdomov.cz/',
  //   bgSrc: 'https://i.imgur.com/OlVYiZv.png',
  //   description: 'Pronájmy bytů a spolubydlení na jedné mapě',
  // },
  // {
  //   title: 'Kiwi',
  //   bgSrc: 'https://i.imgur.com/YvU73No.png',
  //   websiteUrl: 'https://www.kiwi.com/cz/',
  //   description:
  //     'Najděte skryté levné lety a objevte nové destinace pomocí našeho nejmodernějšího vyhledávače letů',
  // },
  // {
  //   title: 'Spendee',
  //   websiteUrl: 'https://www.spendee.com/',
  //   bgSrc: 'https://i.imgur.com/grB6qG0.png',
  //   description: 'Nejoblíběnější aplikací na správu osobních a rodinných financí.',
  // },
  // {
  //   id: 9,
  //   title: 'Brand Embassy',
  //   bgSrc: 'https://i.imgur.com/1BAzcyU.png',
  //   websiteUrl: 'https://www.brandembassy.com/',
  //   description:
  //     'Nástroj umožňující společnostem najít a jednoduše oslovit nespokojené zákazníky v online prostředí.',
  // },
  // {
  //   bgSrc: 'https://i.imgur.com/KZsSH3i.png',
  //   websiteUrl: 'https://altclub.com',
  //   title: 'AltClub',
  //   description: 'Český krypto projekt na výuku obchodování krytomen',
  // },
};
